import Highcharts from 'highcharts';
import HighchartsReact from "highcharts-react-official";
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
/* 
Function Print Chart
Parameters : Props (Object)
*/
Highcharts.setOptions({
	lang: {
		thousandsSep: ','
	}
});
const LineChart = (props) => {
	const { sideBarOpen } = useSelector((state) => state.common);
	// Chart Reference
	const chartRef = useRef(null);
	useEffect(() => {
		if (typeof props.isMap !== "undefined" && props.isMap === true) {
			setTimeout(() => {
				let cont = chartRef.current.chart.container.getBoundingClientRect();
				chartRef.current.chart.setSize(cont.width, cont.height);
			}, 300)
		}
		else {
			setTimeout(() => {
				chartRef.current.chart.reflow();
			}, 300)
		}
	}, [sideBarOpen]);
	useEffect(() => {
		if (props.isMap === true && props.options.setWhiteColor === true) {
			// Get reference to the Highcharts chart instance
			const chart = chartRef.current.chart;
			const colorAxis = chart.colorAxis[0];

			// Get the min and max values from the color axis
			const minValue = colorAxis.series[0].minColorValue;
			const maxValue = colorAxis.series[0].maxColorValue;

			// Calculate the threshold value based on the range of values
			const dynamicThresholdValue = (minValue + maxValue) / 2;
			// Define the threshold value
			const thresholdValue = dynamicThresholdValue;

			// Loop through the series data and add CSS class to data labels based on value
			chart.series.forEach(series => {
				series.points.forEach(point => {
					if (point.value > thresholdValue) {
						point.dataLabel.addClass('high-value-data-label');
					}
				});
			});
		}
	}, [props?.options?.series[0]?.data]);
	useEffect(() => {
		if (chartRef !== null) {
			if (typeof props.setChartRef !== "undefined") props.setChartRef(chartRef.current);
		}
	}, [chartRef])
	return (
		<>
			<HighchartsReact
				allowChartUpdate={true}
				highcharts={Highcharts}
				options={{
					...props.options, chart: { ...props.options.chart, height: 350, backgroundColor: '#FFFFFF' }, accessibility: { enabled: false }, credits: {
						enabled: false
					},
					exporting: {
						enabled: true, // Enable exporting module
						buttons: {
							contextButton: {
								menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF'] // Customize available export options
							}
						}
					}
				}}
				ref={chartRef} />
		</>
	)
}

export default LineChart;